<template>
    <div>
        <div class="weui-cells__tips">{{error}}</div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd">
                    <img src="@/assets/logo-brand.jpg" style="width: 100%"/>
                </div>
            </div>
            <div class="weui-cell weui-cell_select weui-cell_select-before">
                <div class="weui-cell__hd">
                    <select class="weui-select" name="select2">
                        <option value="1">+86</option>
                    </select>
                </div>
                <div class="weui-cell__bd">
                    <input class="weui-input" type="tel" placeholder="请输入手机号" v-model="number" ref="number">
                </div>
            </div>
            <div class="weui-cell">
                <div class="weui-cell__bd">
                    <input class="weui-input" type="password" placeholder="请输入密码" v-model="password" ref="password"/>
                </div>
            </div>
        </div>
        <label for="weuiAgree" class="weui-agree">
            <input id="weuiAgree" type="checkbox" class="weui-agree__checkbox" v-model="remember">
            <span class="weui-agree__text">记住我</span>
        </label>

        <div class="weui-btn-area">
            <button class="weui-btn weui-btn_primary" @click="login()">登录</button>
        </div>
    </div>
</template>

<script>
import { setToken } from '@/utils/functions'

export default {
    name: 'Login',
    data() {
        return {
            number: localStorage.getItem('login-number'),
            password: localStorage.getItem('login-password'),
            remember: localStorage.getItem('login-remember'),
            error: ''
        };
    },
    methods: {
        login() {
            //判断输入的手机号是否合法
            if(!this.number) {
                this.error = "请输入手机号"; 
                this.$refs.number.focus();
                return false;
            } else if(!/^1[345678]\d{9}$/.test(this.number)) {
                this.error = "请输入正确的手机号"; 
                this.$refs.number.focus();
                return false;
            } 
            
            //判断输入的密码是否合法
            if(!this.password) {
                this.error = "请输入密码"; 
                this.$refs.password.focus();
                return false;
            }

            //
            this.$axios.get("user/login", {
                params: {
                    number: this.number,
                    password: this.password
                }
            }).then(response => {
                setToken(response.data.token);

                if (this.remember) {
                    localStorage.setItem('login-number', this.number);
                    localStorage.setItem('login-password', this.password);
                    localStorage.setItem('login-remember', this.remember);
                }
                this.$router.push({ path: '/home' });
            });
        }
    }
}
</script>
